<template>
  <hm-sync :value="value">
    <div>
      <div class="table-panel flex flex-between">
        <div>
          <el-button
            class="mr10"
            type="primary"
            size="small"
            :disabled="value"
            @click="addSpecification"
            >新增辅助属性</el-button
          >
        </div>
        <div>
          <el-input
            clearable
            v-model.trim="keyWords"
            placeholder="属性类型"
            size="small"
            class="ipt mr10"
          ></el-input>
          <el-button type="primary" size="small" @click="search"
            >查询</el-button
          >
          <el-button
            type="success"
            size="small"
            :loading="isOutputing"
            @click="output(allAttributeList, 'attrTable', '辅助属性列表')"
            >导出</el-button
          >
        </div>
      </div>

      <div class="table text-center">
        <el-table
          @sort-change="sortChange"
          stripe
          ref="attrTable"
          :data="attributeList.records"
          style="width: 100%"
          id="table"
          size="small"
          border
        >
          <el-table-column
            header-align="center"
            align="center"
            type="index"
            label="序号"
            width="50"
            :index="index => index + (currentPage - 1) * pageSize + 1"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="typeName"
            label="属性类型"
          ></el-table-column>
          <el-table-column
            header-align="center"
            show-overflow-tooltip
            align="center"
            prop="attributeNum"
            label="属性数量"
            sortable
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="valueNum"
            label="属性值数量"
            sortable
          ></el-table-column>
          <el-table-column label="操作" header-align="center" align="center">
            <template slot-scope="scope">
              <div class="flex flex-center">
                <el-tooltip class="item" content="查看" placement="top">
                  <button
                    class="pointer mr10 no-bg"
                    @click="toDetails(scope.row)"
                  >
                    <span class="hmicon icon-chakan blue"></span>
                  </button>
                </el-tooltip>
                <el-tooltip class="item" content="编辑" placement="top">
                  <button class="pointer mr10 no-bg" @click="edit(scope.row)">
                    <span class="hmicon icon-bianji blue"></span>
                  </button>
                </el-tooltip>
                <el-tooltip class="item" content="删除" placement="top">
                  <button class="pointer mr10 no-bg" @click="remove(scope.row)">
                    <span class="hmicon icon-shanchu primary"></span>
                  </button>
                </el-tooltip>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="hm-pagination">
        <el-pagination
          background
          :total="attributeList.total"
          @current-change="paging"
          @size-change="handleSizeChange"
          :page-sizes="[10, 50, 100, 200]"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="currentPage"
          :page-size="pageSize"
        ></el-pagination>
      </div>
    </div>
  </hm-sync>
</template>

<script>
import HmSync from "@/components/HmIsSync";
import { outPutMixin } from "@/mixins/outputMixin";
import { mapGetters } from "vuex";
import { setCookie, getCookie } from "@/utils/utils";
export default {
  components: { HmSync },
  mixins: [outPutMixin],
  data() {
    return {
      keyWords: "",
      pageSize: 10,
      value: false,
      actName: "",
      isOutputing: false,
      currentPage: 1,
      sort: {}
    };
  },
  computed: mapGetters(["attributeList", "allAttributeList"]),
  mounted() {
    this.getParamsCookie();
    this.queryList();
  },
  methods: {
    toDetails(row) {
      this.$router.push({
        name: "AttrDetails",
        query: {
          id: row.typeId
        }
      });
    },
    sortChange(sort) {
      this.sort = sort;
      this.queryList();
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    addSpecification() {
      this.$router.push({
        name: "AddAttribute"
      });
    },
    edit(row) {
      this.$router.push({
        name: "EditAttribute",
        query: {
          id: row.typeId
        }
      });
    },
    handleSizeChange(size) {
      this.pageSize = size;
      this.currentPage = 1;
      this.queryList();
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    queryList(queryAll) {
      const params = {
        pageSize: queryAll ? 99999 : this.pageSize,
        pageNo: this.currentPage,
        keyWords: this.keyWords,
        order: this.sort.order,
        prop: this.sort.prop
      };
      this.setParamsCookie();
      const actionName = queryAll
        ? "queryAllAttributeList"
        : "queryAttributeList";
      return this.$store.dispatch(actionName, params);
    },
    setParamsCookie() {
      let searchCondition = {
        keyWords: this.keyWords,
        order: this.sort.order,
        prop: this.sort.prop
      };
      setCookie({
        key: "attributeParams",
        type: "session",
        data: Object.assign({}, searchCondition, {
          pageSize: this.pageSize,
          currentPage: this.currentPage
        })
      });
    },
    getParamsCookie() {
      const prams = getCookie({ key: "attributeParams", type: "session" });
      if (prams) {
        this.keyWords = prams.keyWords;
        this.sort.order = prams.order;
        this.sort.prop = prams.prop;
        this.pageSize = prams.pageSize;
        this.currentPage = prams.currentPage;
      }
    },
    remove(row) {
      this.$confirm(" 删除本行数据?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$store
          .dispatch("deleteAttribute", {
            typeId: row.typeId
          })
          .then(res => {
            if (res.code === "0") {
              this.$message({
                message: "操作成功",
                type: "success"
              });
              this.queryList();
            }
          });
      });
    }
  }
};
</script>
<style scoped lang="scss">
.title {
  font-size: 22px;
  font-weight: bold;
}
.switch {
  margin-right: 40%;
}
</style>
